import { TextEllipsis } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';
import { memo, useState } from 'react';
import { EmailSettingsHeader } from './components/email-settings-header';
import * as Styled from './styles';
import * as SX from './sx';
import type { EmailSettingsProps as Props } from './types';

export const EmailSettings = memo(({ className }: Props) => {
  const [currentEmail, setCurrentEmail] = useState('');

  return (
    <Styled.Wrapper
      className={classnames('EmailSettings', className)}
      sx={SX.root}
    >
      <EmailSettingsHeader
        currentEmail={currentEmail}
        setCurrentEmail={setCurrentEmail}
      />

      <Stack>
        <Typography variant="body4" color="grey.600" fontWeight={500}>
          Billing send to
        </Typography>
        <TextEllipsis
          variant="body5"
          color="grey.500"
          fontWeight={400}
          width="300px"
        >
          {currentEmail || 'No email available'}
        </TextEllipsis>
      </Stack>
    </Styled.Wrapper>
  );
});

EmailSettings.displayName = 'EmailSettings';
